/**
 * A page's template settings, never null. Saving a page with empty settings
 * ({}) stores none (Mongoose leaves out empty objects), so the page comes back
 * with null, and templates read their settings directly (templateSettings.pageTitle):
 * the editor canvas, previews and deploys would all fail to draw the page.
 */
export const templateSettingsOf = (template?: { props?: unknown } | null): Record<string, unknown> => {
  const props = template && template.props;
  return props && typeof props === 'object' && !Array.isArray(props) ? props as Record<string, unknown> : {};
};
